module.exports = __webpack_public_path__ + "img/airbnb_logo.52765510.png";